import axios from "axios"

const COUNTRYS = {
  US: "United States",
  IL: "Israel",
  UA: "Ukraine",
  IN: "India"
}
export const ComeetToJson = async () => {
  const token =
    "nFjde5Skw6A1mLRzTHyj8bqpZxU0XutKO9QGWVPvECM7Bh2YcIriogDta3Nslf4"

  const jobs = await axios.get(
    `https://n9qqipke00.execute-api.us-east-2.amazonaws.com/prod/get-comeet-jobs?token=${token}`
  )

  return jobs.data.map(job => ({
    isComeetJob: true,
    country: {
      country: COUNTRYS[job.location.country] || job.location.country,
      flagIcon: {},
    },
    department: job.department,
    description:
      job.details[0].name === "Description" ? job.details[0].value : "",
    link: job.url_comeet_hosted_page,
    location: job.location.name === "Israel" ? "Tel Aviv" : job.location.city,
    title: job.name,
  }))
}
